import React, { createContext, ReactNode } from 'react';

import { SelectedParticipantProvider } from './useSelectedParticipant';

//import AttachVisibilityHandler from './AttachVisibilityHandler';
import useHandleRoomDisconnectionErrors from './useHandleRoomDisconnectionErrors';
import useHandleOnDisconnect from './useHandleOnDisconnect';
import useHandleTrackPublicationFailed from './useHandleTrackPublicationFailed';
import useLocalTracks from './useLocalTracks';
import useRoom from './useRoom';
import { endCall, Logger } from '../../utils';
import useScreenShareToggle from './useScreenShareToggle';

/*
 *  The hooks used by the VideoProvider component are different than the hooks found in the 'hooks/' directory. The hooks
 *  in the 'hooks/' directory can be used anywhere in a video application, and they can be used any number of times.
 *  the hooks in the 'VideoProvider/' directory are intended to be used by the VideoProvider component only. Using these hooks
 *  elsewhere in the application may cause problems as these hooks should not be used more than once in an application.
 */

export const VideoContext = createContext(null);

export function VideoProvider({ options, children, onError = () => { }, onDisconnect = () => { }, kickoutGuest }) {
    const onErrorCallback = error => {
        console.log(`ERROR: ${error.message}`, error);
        onError(error);
        const { message, code, name } = error || {};
        Logger("UI.Twilio.Room.Error", new Date(),
            {
                "name": name ? name : "",
                "code": code ? code : "",
                "message": message ? message : "",
            });
        endCall();
    };

    const onPublishErrorCallback = error => {
        console.log(`ERROR:`, error);
        Logger("UI.Twilio.Room.onPublishError", new Date(), error);
    };

    const {
        localTracks,
        getLocalVideoTrack,
        getLocalAudioTrack,
        isAcquiringLocalTracks,
        removeLocalVideoTrack,
        //      createTracks,
        removeLocalAudioTrack,
        getAudioAndVideoTracks,
        isAcquiringLocalTracksCompleted
    } = useLocalTracks(onErrorCallback);
    const { room, isConnecting, connect } = useRoom(localTracks, onErrorCallback, options);

    // Register onError and onDisconnect callback functions.
    useHandleRoomDisconnectionErrors(room, onError);
    useHandleTrackPublicationFailed(room, onPublishErrorCallback);
    useHandleOnDisconnect(room, onDisconnect);
    const [isSharingScreen, toggleScreenShare] = useScreenShareToggle(room, onError);

    return (
        <VideoContext.Provider
            value={{
                room,
                localTracks,
                isConnecting,
                onError: onErrorCallback,
                onDisconnect,
                getLocalVideoTrack,
                getLocalAudioTrack,
                connect,
                isAcquiringLocalTracks,
                removeLocalVideoTrack,
                //  isPublishingTracks,
                isSharingScreen,
                toggleScreenShare,
                removeLocalAudioTrack,
                getAudioAndVideoTracks,
                kickoutGuest,
                isAcquiringLocalTracksCompleted
            }}
        > <SelectedParticipantProvider room={room}>{children}</SelectedParticipantProvider>
        </VideoContext.Provider>
    );
}
